import React from "react";
import { Card, Button, Table, Badge } from "react-bootstrap";
import { IconRefresh } from "@tabler/icons-react";
import LayoutAgentRank from "layouts/layout-agent-rank";
import {
  AgentRewardProvider,
  useAgentReward,
} from "./context/AgentRewardContext";

function AgentRankRewardContent() {
  const { agentRewards, refetch, Pagination } = useAgentReward();

  const getRankingColor = (ranking) => {
    switch (ranking) {
      case "Platinum":
        return "#60a5fa"; // blue-400
      case "Gold":
        return "#fbbf24"; // yellow-400
      case "Silver":
        return "#6b7280"; // gray-500
      case "Bronze":
        return "#92400e"; // amber-800
      default:
        return "#6b7280"; // gray-500
    }
  };

  const getRankingTextColor = (ranking) => {
    switch (ranking) {
      case "Platinum":
      case "Gold":
        return "#000000"; // black text for light backgrounds
      default:
        return "#ffffff"; // white text for dark backgrounds
    }
  };

  const getClaimStatusColor = (status) => {
    switch (status) {
      case "claimed":
      case "Claimed":
        return "#10b981"; // green-500
      case "pending":
      case "Pending":
        return "#f59e0b"; // amber-500
      case "not_claimed":
      case "Not Claimed":
      default:
        return "#ef4444"; // red-500
    }
  };

  return (
    <LayoutAgentRank>
      <div className="container-fluid mt-5">
        <h1>AGENT RANKING - REWARDS</h1>

        <div
          style={{
            minHeight: "100vh",
            backgroundColor: "#f9fafb",
            padding: "16px",
          }}
        >
          <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                }}
              >
                <h2 style={{ fontSize: "20px", fontWeight: "600" }}>
                  Rewards Claims History
                </h2>
                <Button
                  variant="outline-info"
                  onClick={refetch}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <IconRefresh size={16} />
                  Refresh Data
                </Button>
              </div>

              <Card>
                <div style={{ padding: "0" }}>
                  <Table striped bordered hover style={{ marginBottom: "0" }}>
                    <thead>
                      <tr>
                        <th style={{ width: "64px" }}># No</th>
                        <th>📋 Nama</th>
                        <th style={{ textAlign: "center" }}>🎯 Rangking</th>
                        <th>📝 Rewards</th>
                        <th style={{ textAlign: "center" }}>📅 Season</th>
                        <th style={{ textAlign: "center" }}>🎯 Status Klaim</th>
                      </tr>
                    </thead>
                    <tbody>
                      {agentRewards?.loading ? (
                        <tr>
                          <td
                            colSpan="6"
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            <div className="d-flex justify-content-center align-items-center">
                              <div
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                              Loading rewards data...
                            </div>
                          </td>
                        </tr>
                      ) : agentRewards?.error ? (
                        <tr>
                          <td
                            colSpan="6"
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            <div className="alert alert-danger" role="alert">
                              <strong>Error loading rewards:</strong>{" "}
                              {agentRewards.error}
                            </div>
                          </td>
                        </tr>
                      ) : agentRewards?.data?.length > 0 ? (
                        agentRewards.data.map((row, index) => (
                          <tr key={row.id || index}>
                            <td style={{ fontWeight: "500" }}>{index + 1}</td>
                            <td>{row.agent?.name || "Unknown Agent"}</td>
                            <td style={{ textAlign: "center" }}>
                              <Badge
                                style={{
                                  backgroundColor: getRankingColor(
                                    row.tier?.name
                                  ),
                                  color: getRankingTextColor(row.tier?.name),
                                }}
                              >
                                {row.tier?.name || "Unknown"}
                              </Badge>
                            </td>
                            <td style={{ maxWidth: "320px" }}>
                              {row.reward || "-"}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                color: "#6c757d",
                              }}
                            >
                              {row.season?.name || "Unknown Season"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <Badge
                                style={{
                                  backgroundColor: getClaimStatusColor(
                                    row.claim_status
                                  ),
                                  color: "#ffffff",
                                }}
                              >
                                {row.claim_status || "Not Claimed"}
                              </Badge>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            No reward data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {Pagination && (
                    <div style={{ padding: "16px" }}>{Pagination}</div>
                  )}
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </LayoutAgentRank>
  );
}

export default function AgentRankReward() {
  return (
    <AgentRewardProvider>
      <AgentRankRewardContent />
    </AgentRewardProvider>
  );
}
